import { VStack, StackProps } from '@chakra-ui/react';

const ProductFieldWrapper = (props: StackProps) => (
  <VStack
    sx={{
      justifyContent: 'flex-start',
      bgColor: 'base2Colour.500',
      my: 1.5,
      alignItems: 'space-between',
      fontSize: 'sm',
      color: 'base2FontColour.500',
    }}
    {...props}
  />
);

export default ProductFieldWrapper;
